import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { PermissionsService } from '../services/permissions.service';

@Injectable({
  providedIn: 'root'
})
export class AdvancedEditorGuard implements CanActivate {

  constructor(
    private permissionsService: PermissionsService,
    private router: Router
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    console.log('🔒 AdvancedEditorGuard: Checking access to:', state.url);
    
    try {
      // Verificar si el usuario es un usuario principal (no miembro)
      const isMainUser = await this.permissionsService.isMainUser();
      console.log('🔒 AdvancedEditorGuard: isMainUser =', isMainUser);
      
      // Verificar si el usuario puede usar el editor avanzado
      const canUseAdvancedEditor = await this.permissionsService.canUseAdvancedEditor();
      console.log('🔒 AdvancedEditorGuard: canUseAdvancedEditor =', canUseAdvancedEditor);
      
      // Los usuarios principales siempre tienen acceso al editor avanzado
      // Los miembros necesitan el permiso específico
      const hasAccess = isMainUser || canUseAdvancedEditor;
      console.log('🔒 AdvancedEditorGuard: hasAccess =', hasAccess);
      
      if (!hasAccess) {
        console.log('🔒 AdvancedEditorGuard: Access DENIED - Redirecting to /agents');
        // Redirigir a la página de agentes si no tiene permisos
        this.router.navigate(['/agents']);
        return false;
      }
      
      console.log('🔒 AdvancedEditorGuard: Access GRANTED - Allowing navigation to generator');
      return true;
    } catch (error) {
      console.error('🔒 AdvancedEditorGuard: Error checking permissions:', error);
      console.log('🔒 AdvancedEditorGuard: Error occurred - Redirecting to /agents');
      this.router.navigate(['/agents']);
      return false;
    }
  }
} 